import gql from 'graphql-tag'

const FETCH_LIGHTSPEED_LOCATIONS = gql`
  query FetchLightspeedIds {
    fetchLightspeedIds {
      id
      name
      businessLocations {
        id
        name
      }
    }
  }
`

const GET_LIGHTSPEED_STORES = gql`
  query getLightspeedStores($merchantId: uuid!) {
    stores(where: { merchant_id: { _eq: $merchantId } }) {
      id
      name
      store_integration_settings {
        lightspeed_menus
        lightspeed_business_id
        lightspeed_business_name
        lightspeed_business_location_id
        lightspeed_business_location_name
        lightspeed_order_profile_mapping
        lightspeed_last_menu_push_at
      }
    }
  }
`

const UPDATE_STORE_INTEGRATION = gql`
  mutation UpdateStoreIntegrationSettings(
    $partnerName: PartnerName!
    $storeId: uuid!
    $lightspeedBusinessId: Int
    $lightspeedBusinessName: String
    $lightspeedMenus: [LightspeedMenuInput]
    $lightspeedBusinessLocationId: Int
    $lightspeedBusinessLocationName: String
    $lightspeedOrderProfileMapping: LightspeedOrderProfileMappingInput
  ) {
    updateStoreIntegrationSettings(
      partnerName: $partnerName
      storeId: $storeId
      lightspeedBusinessId: $lightspeedBusinessId
      lightspeedBusinessName: $lightspeedBusinessName
      lightspeedMenus: $lightspeedMenus
      lightspeedBusinessLocationId: $lightspeedBusinessLocationId
      lightspeedBusinessLocationName: $lightspeedBusinessLocationName
      lightspeedOrderProfileMapping: $lightspeedOrderProfileMapping
    ) {
      integrationSettings {
        lightspeedMenus {
          id
          name
        }
        lightspeedBusinessId
        lightspeedBusinessName
        lightspeedLastMenuPushAt
        lightspeedBusinessLocationId
        lightspeedBusinessLocationName
        lightspeedOrderProfileMapping {
          delivery
          pickup
          orderAtTable
        }
      }
    }
  }
`

const FETCH_MENUS = gql`
  query GetMenus($partnerName: PartnerName!, $storeId: uuid!) {
    fetchPartnerMenus(partnerName: $partnerName, storeId: $storeId) {
      id
      name
    }
  }
`

const REQUEST_PUSH_MENU = gql`
  mutation RequestMenuPush($partnerName: PartnerName!, $storeId: uuid!) {
    requestMenuPush(partnerName: $partnerName, storeId: $storeId) {
      integrationSettings {
        lightspeedLastMenuPushAt
      }
    }
  }
`

const GET_LIGHTSPEED_ORDER_PROFILES = gql`
  query GetLightspeedOrderProfiles($storeId: uuid!) {
    getLightspeedOrderProfiles(storeId: $storeId) {
      code
      deliveryMode
    }
  }
`

export {
  FETCH_LIGHTSPEED_LOCATIONS,
  UPDATE_STORE_INTEGRATION,
  FETCH_MENUS,
  REQUEST_PUSH_MENU,
  GET_LIGHTSPEED_ORDER_PROFILES,
  GET_LIGHTSPEED_STORES
}
